import Auth from '../auth/Auth';
import Option from '../models/Option';
import { WebClient } from './WebClient'

class ApiOption extends WebClient {
    async getOptions(): Promise<Option[]> {
        const url = "/option";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateOption(data: Option): Promise<Option> {
        return this.put("/option", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }
}

export default new ApiOption();
